import { Link } from "react-router-dom";

export default function OnboardingNav({ hasProgress, progressProp = 0 }) {
  const isLoginPage = window.location.href.includes("login");
  const authLink = isLoginPage ? "/onboarding" : "/login";
  const authText = isLoginPage ? "Non hai un profilo?" : "Hai già un account?";
  const authButtonText = isLoginPage ? "Registrati" : "Accedi";

  return (
    <div className="fixed top-0 z-10 w-full bg-gray-50">
      <div className="w-full h-fit flex justify-between items-center md:px-32 px-4 md:py-4 py-[20px]">
        <img
          className="md:w-40 w-24"
          src="assets/images/logo/lockup.svg"
          alt="Athena Logo"
        />
        <span className="md:text-16 text-12">
          {authText}
          <Link to={authLink}>
            <span className="ms-1 underline text-accent">{authButtonText}</span>
          </Link>
        </span>
      </div>
      {hasProgress && (
        <div className="w-full h-1 rounded-full overflow-hidden bg-gray-150">
          <div
            className="h-full bg-accent transition-all duration-500 rounded-r"
            style={{ width: `${progressProp}%` }}
          ></div>
        </div>
      )}
    </div>
  );
}
